import { Component, OnInit } from '@angular/core';

import { AppData } from 'src/app/services/appdata.service';
import { Global } from 'src/app/services/global.service';
import { InsightService } from 'src/app/services/insight.service';

import { Config } from 'src/app/models/env-vars.model';

import {} from 'googlemaps';
declare var MarkerClusterer: any;
declare var AmCharts: any;
declare let google: any;

let zepi_drawn = false, map_drawn = false, water_drawn = false, waste_drawn = false;

@Component({
  selector: 'app-insight-market',
  templateUrl: './insight-market.component.html',
  styleUrls: ['./insight-market.component.css']
})
export class InsightMarketComponent implements OnInit
{
	zipcode: string = this.global.getURLFromParam('zipcode');
	zipcode_input: string = this.global.getURLFromParam('zipcode');
	range_in_mile: any = this.global.getURLFromParam('range_in_mile');
	range_in_mile_input: any = this.global.getURLFromParam('range_in_mile');
	country: string = this.global.getURLFromParam('country');
	project_type_list: string[] = ["Datacenter", "Educational Facilities", "Health Care", "Higher Ed", "Industrial Manufacturing", "K-12", "Laboratory", "Lodging", "Military Base", "Multi-Family Residential", "Neighborhood Development", "Office: Mixed Use", "Office", "Other", "Public Assembly", "Public Order and Safety", "Religious Worship", "Retail", "Service", "Single-Family Home", "Warehouse and Distribution"];
	metric_tab: string = 'Projects';
	page_size: number = 0;
	page_number: number = 0;
	pages: number = 0;
	loading_data: boolean = false;
	searching_zip: boolean = false;
	init_chart: boolean = false;

	canceler: any;
	project_types_input: any = [];
	zipcode_list: any = [];
	project_certs: any = [];
	project_list: any = [];
	range_list: any = [];
	project_types: any = [];
	insight_data: any = {
		"reduction": {
			"energy": {
				"list": [],
				"meta": {}
			},
			"water": {
				"list": [],
				"meta": {}
			},
			"waste": {
				"list": [],
				"meta": {}
			},
			"zepi_list": []
		},
		"total_projects": 0
	}
	map_styles: any = [{"featureType":"all","elementType":"labels.text.fill","stylers":[{"color":"#7c93a3"},{"lightness":"-10"}]},{"featureType":"administrative.country","elementType":"geometry","stylers":[{"visibility":"on"}]},{"featureType":"administrative.country","elementType":"geometry.stroke","stylers":[{"color":"#a0a4a5"}]},{"featureType":"administrative.province","elementType":"geometry.stroke","stylers":[{"color":"#62838e"}]},{"featureType":"landscape","elementType":"geometry.fill","stylers":[{"color":"#dde3e3"}]},{"featureType":"landscape.man_made","elementType":"geometry.stroke","stylers":[{"color":"#3f4a51"},{"weight":"0.30"}]},{"featureType":"poi","elementType":"all","stylers":[{"visibility":"simplified"}]},{"featureType":"poi.attraction","elementType":"all","stylers":[{"visibility":"on"}]},{"featureType":"poi.business","elementType":"all","stylers":[{"visibility":"off"}]},{"featureType":"poi.government","elementType":"all","stylers":[{"visibility":"off"}]},{"featureType":"poi.park","elementType":"all","stylers":[{"visibility":"on"}]},{"featureType":"poi.place_of_worship","elementType":"all","stylers":[{"visibility":"off"}]},{"featureType":"poi.school","elementType":"all","stylers":[{"visibility":"off"}]},{"featureType":"poi.sports_complex","elementType":"all","stylers":[{"visibility":"off"}]},{"featureType":"road","elementType":"all","stylers":[{"saturation":"-100"},{"visibility":"on"}]},{"featureType":"road","elementType":"geometry.stroke","stylers":[{"visibility":"on"}]},{"featureType":"road.highway","elementType":"geometry.fill","stylers":[{"color":"#bbcacf"}]},{"featureType":"road.highway","elementType":"geometry.stroke","stylers":[{"lightness":"0"},{"color":"#bbcacf"},{"weight":"0.50"}]},{"featureType":"road.highway","elementType":"labels","stylers":[{"visibility":"on"}]},{"featureType":"road.highway","elementType":"labels.text","stylers":[{"visibility":"on"}]},{"featureType":"road.highway.controlled_access","elementType":"geometry.fill","stylers":[{"color":"#ffffff"}]},{"featureType":"road.highway.controlled_access","elementType":"geometry.stroke","stylers":[{"color":"#a9b4b8"}]},{"featureType":"road.arterial","elementType":"labels.icon","stylers":[{"invert_lightness":true},{"saturation":"-7"},{"lightness":"3"},{"gamma":"1.80"},{"weight":"0.01"}]},{"featureType":"transit","elementType":"all","stylers":[{"visibility":"off"}]},{"featureType":"water","elementType":"geometry.fill","stylers":[{"color":"#a3c7df"}]}];

	constructor(
		public appData: AppData,
		public global: Global,
		private insight: InsightService
	)
	{

	}

	ngOnInit(): void
	{
		if(this.global.getURLFromParam('project_type') == undefined)
		{
			this.project_types_input = [];
			this.project_types = [];
		}
		else
		{
			this.project_types_input = decodeURIComponent(this.global.getURLFromParam('project_type')).split(",");
			this.project_types = decodeURIComponent(this.global.getURLFromParam('project_type')).split(",");   
		}

		if(this.zipcode == undefined)
		{
			this.zipcode = "2101 L Street, NW, Washington, DC 20037";
			this.zipcode_input = "2101 L Street, NW, Washington, DC 20037";
		}
		if(this.range_in_mile == undefined)
		{
			this.range_in_mile = 1;
			this.range_in_mile_input = 1;
		}
		if(this.country == undefined)
		{
			this.country = 'US';
		}

		this.range_list = this.generateRange(150, 5);
        this.searchData(this.range_in_mile_input, this.zipcode_input, this.project_types_input);
	}

	generateRange(max: number, diff: number)
	{
		var range = [1];
		for(var i = 1; i <= max; i++)
		{    
			if(i % diff == 0)
			{
				range.push(i);
			}
		}
		return range;
	};

	checkPreq(credit: any): any
	{
		if(credit.credit_id.indexOf("p") == -1)
		{
			return false
		}
		else
		{
			credit.count = 100.00
			return true
		}
	}

	disableSearch(): any
	{
		if(this.zipcode == this.zipcode_input && this.range_in_mile == this.range_in_mile_input && this.project_types_input.join(',').trim().replace(/ /g, "").replace(/\n/g, "") == this.project_types.join(',').trim().replace(/ /g, "").replace(/\n/g, ""))
		{
			return true;
		} 
	}

	searchZipCode(zipcode: any)
	{
		this.searching_zip = true;
		if(this.canceler)
		{
			this.canceler.unsubscribe();
		}

		this.canceler = this.insight.getZipList(zipcode).subscribe(
			data =>
			{
				this.searching_zip = false;
				this.zipcode_list = data;
				this.showDropdown();
			},
			error =>
			{
				this.searching_zip = false;
			}
		);
	}

	projectTypeChange()
	{
		this.disableSearch();
	}

	changeZipCode(zipcode: any)
	{
		this.zipcode_input = zipcode;
	}

	changeRange(range_in_mile: any)
	{
		this.range_in_mile_input = range_in_mile;
	}

	initPage()
	{
		var certified = 0;
		var gold = 0;
		var silver = 0;
		var platinum = 0;
		var map_provider = [];
		var targetSVG = "M9,0C4.029,0,0,4.029,0,9s4.029,9,9,9s9-4.029,9-9S13.971,0,9,0z M9,15.93 c-3.83,0-6.93-3.1-6.93-6.93S5.17,2.07,9,2.07s6.93,3.1,6.93,6.93S12.83,15.93,9,15.93 M12.5,9c0,1.933-1.567,3.5-3.5,3.5S5.5,10.933,5.5,9S7.067,5.5,9,5.5 S12.5,7.067,12.5,9z";

		for(var i = 0; i < this.insight_data.reduction.zepi_list.length; i++)
		{
			if(this.insight_data.reduction.zepi_list[i].certification_level != null && this.insight_data.reduction.zepi_list[i].certification_level.toLowerCase().indexOf("platinum") > -1)
			{
				platinum += 1;
			}
			else if(this.insight_data.reduction.zepi_list[i].certification_level != null && this.insight_data.reduction.zepi_list[i].certification_level.toLowerCase().indexOf("silver") > -1)
			{
				silver += 1;
			}
			else if(this.insight_data.reduction.zepi_list[i].certification_level != null && this.insight_data.reduction.zepi_list[i].certification_level.toLowerCase().indexOf("gold") > -1)
			{
				gold += 1;
			}
			else
			{
				certified += 1;
			}

			map_provider.push({
				'name': this.insight_data.reduction.zepi_list[i].name,
				'id': this.insight_data.reduction.zepi_list[i].id,
				'certification_level': this.insight_data.reduction.zepi_list[i].certification_level,
				'lat': parseFloat(this.insight_data.reduction.zepi_list[i].lat),
				'lng': parseFloat(this.insight_data.reduction.zepi_list[i].lng)
			});
		}

		this.project_certs = [
			['Certification', 'No. of Projects'],
			['LEED Certified', certified],
			['LEED Gold', gold],
			['LEED Silver', silver],
			['LEED Platinum', platinum]
		];

		this.drawMap(map_provider);
	};

	drawMap(map_provider: any)
	{
		var styles_hide = 
		{
			default: [],
			hide: 
			[
				{
					featureType: "road", stylers: [ { visibility: "off" } ]
				}
			],
		};
		var styles_show = 
		{
			default: [],
			hide: 
			[
				{
					featureType: "road", stylers: [ { visibility: "on" } ]
				}
			],
		};
		var map_meta: any = {zoom: 11};
		if(map_provider.length > 0)
		{
			map_meta["center"] = map_provider[0];
			map_meta["styles"] = this.map_styles;
		}
		var infoWin = new google.maps.InfoWindow();
		var map: any = new google.maps.Map(<any>(document.getElementById('world_map')), map_meta);
		map.setOptions({ styles: styles_hide["hide"] });
		var markers = map_provider.map(function(location: any, i: any)
		{
			var marker = new google.maps.Marker(
			{
				position: location
			});

			google.maps.event.addListener(marker, 'click', function(evt: any)
			{
				infoWin.setContent(location.name + " - " + String(parseInt(location.id)) + " (" + location.certification_level + ")");
				infoWin.open(map, marker);
			})

			return marker;
		});
		map.addListener("zoom_changed", function(e: any)
		{
			if(map.getZoom() >= 15)
			{
				map.setOptions({ styles: styles_show["hide"] });
			}
			else
			{
				map.setOptions({ styles: styles_hide["hide"] });
			}
		});
		var marker = new google.maps.Marker({position: map_meta["center"], map: map});
		var bounds  = new google.maps.LatLngBounds();
		var markerCluster = new MarkerClusterer(map, markers,
		{
			imagePath: 'https://developers.google.com/maps/documentation/javascript/examples/markerclusterer/m'
		});
		this.mapResize();
	};

	mapResize()
	{
		if(map_drawn)
		{
			return;
		}

		function stopMapTrack()
		{
			clearInterval(mapResizeTrack);
			map_drawn = true;
		}

		var mapResizeTrack = setInterval(function()
		{
			try
			{
				var $el: any = $('.project_metrics'),
				scrollTop: any = $(window).scrollTop(),
				scrollBot = scrollTop + $(window).height(),
				elTop = $el.offset().top,
				elBottom = elTop + $el.outerHeight(),
				visibleTop = elTop < scrollTop ? scrollTop : elTop,
				visibleBottom = elBottom > scrollBot ? scrollBot : elBottom;
				$('.world_map_wrapper').css("height", (visibleBottom - visibleTop - 20) + "px");
				stopMapTrack();
			}
			catch(e)
			{

			}
		}, 1);
	}

	searchData(range_in_mile_input: any, zipcode_input: any, project_types_input: any)
	{
		this.loading_data = true;
		zepi_drawn = false, map_drawn = false, water_drawn = false, waste_drawn = false;
		this.insight.getData(range_in_mile_input, zipcode_input, project_types_input, true, true).subscribe(
			data =>
			{
				(<any>$("#project_type")).selectpicker('render');

				(<any>$('#project_type')).selectpicker('val', this.project_types);

				if('strategies' in data)
				{
					for(var a in data.strategies)
					{
						for(var b = 0; b < data.strategies[a].data.length; b++)
						{
							data.strategies[a].data[b].count = 100 * (data.strategies[a].data[b].count / data.total_projects);
						}
						data.strategies[a].data = data.strategies[a].data.sort(function(a: any, b: any)
						{
							var comp = (parseInt((a['count'] + "").toLowerCase()) > parseInt((b['count'] + "").toLowerCase())) ? 1 : -1;
							return comp;
						});
					}
				}

				this.insight_data = data;

				this.page_size = 10;
				this.pages = Math.ceil(data.reduction.zepi_list.length / this.page_size);
				this.paginateArray(data.reduction.zepi_list, this.page_size, 1);

				(<any>google).load("visualization", "1", {packages:["corechart"]});
				this.initPage();
				this.loading_data = false;

				this.zipcode = zipcode_input
				this.range_in_mile = range_in_mile_input
				this.project_types = this.project_types_input
				this.toggleMetrics(this.metric_tab);
				setTimeout(() =>
				{
					this.initPieChart();
				}, 3000)
			},
			(data) =>
			{
				this.loading_data = false;
			}
		);
	}

	exportInsight(range: any, zipcode: any)
	{
		this.loading_data = true;

		var url = '/overviewexport/?zip_code='+ String(zipcode) +'&range_in_mile=' + String(range) + "&timezone_offset=" + new Date().getTimezoneOffset();

		if(this.project_types_input.length > 0)
		{
			url += "&project_type=" + this.insight.getProjectTypes(this.project_types_input);
		}
		
		this.insight.get(url).subscribe((response) =>
		{
			this.loading_data = false;
			this.global.anchorDownload("Market Overview Export.pdf", JSON.parse(response.data_export));
		},
		error =>
		{
			this.loading_data = false;
		});
	}

	zEPIChart(chartData: any)
	{
		if(zepi_drawn)
		{
			return;
		}
		var data_histogram = [];
		for(var n = 0; n <= 10; n++)
		{
			data_histogram.push({
				"reduction": n,
				"projects": 0,
			});
		}

		for(var j = 0; j < chartData.length; j++)
		{
			var zepi_score = chartData[j].zepi_score;
			var projects = chartData[j].metric;

			if(zepi_score == 100)
			{
				data_histogram[10]['projects'] += projects;
			}
			else if(zepi_score >= 90 && zepi_score < 100)
			{
				data_histogram[9]['projects'] += projects;
			}
			else if(zepi_score >= 80 && zepi_score < 90)
			{
				data_histogram[8]['projects'] += projects;
			}
			else if(zepi_score >= 70 && zepi_score < 80)
			{
				data_histogram[7]['projects'] += projects;
			}
			else if(zepi_score >= 60 && zepi_score < 70)
			{
				data_histogram[6]['projects'] += projects;
			}
			else if(zepi_score >= 50 && zepi_score < 60)
			{
				data_histogram[5]['projects'] += projects;
			}
			else if(zepi_score >= 40 && zepi_score < 50)
			{
				data_histogram[4]['projects'] += projects;
			}
			else if(zepi_score >= 30 && zepi_score < 40)
			{
				data_histogram[3]['projects'] += projects;
			}
			else if(zepi_score >= 20 && zepi_score < 30)
			{
				data_histogram[2]['projects'] += projects;
			}
			else if(zepi_score >= 10 && zepi_score < 20)
			{
				data_histogram[1]['projects'] += projects;
			}
			else if(zepi_score >= 0 && zepi_score < 10)
			{
				data_histogram[0]['projects'] += projects;
			}
		}

		var ballon = '<div class="ballon"><p class="heading">Project(s)</p><div class="values">[[projects]]</div></div>';
		var fontSize = 13;
		var valueAxes = [
		{
			"axisAlpha": 0,
			"gridAlpha": 0.5,
			"gridColor": "#DDDDDD",
			"axisColor": "#DDDDDD",
			"position": "left",
			"title": "",
			"minimum": 0,
			"labelsEnabled": true,
			"stackType": "regular",
			"color": "#68737D",
			"titleColor": "#68737D",
			"fontSize": fontSize
		}];
		var chart = AmCharts.makeChart("zepi_chart",
		{
			"type": "serial",
			"theme": "none",
			"addClassNames": true,
			"dataProvider": data_histogram.reverse(),
			"valueAxes": valueAxes,
			"graphs": [
			{
				"id": "g1",
				"balloonText": ballon,
				"bulletBorderAlpha": 1,
				"bulletColor": "#FFFFFF",
				"hideBulletsCount": 50,
				"valueField": "projects",
				"useLineColorForBulletBorder": true,
				"lineColor": "#949EAB",
				"lineThickness": 2,
				"bulletBorderThickness": 2,
				"balloonColor": "white",
				"balloon": {
					"borderAlpha": 0,
					"borderThickness": 0,
					"fillAlpha": 0
				},
				"type":"column",
				"fillAlphas": 0.9,
				"lineAlpha": 0.2,
				"fixedColumnWidth": 24,
				"labelText": "[[projects]]",
				"labelPosition": "top",
			}],
			"chartCursor":
			{
				"limitToGraph": "g1",
				"cursorColor": "#949EAB"
			},
			"categoryField": "reduction",
			"categoryAxis":
			{
				"parseDates": false,
				"axisColor": "lightgrey",
				"gridAlpha": 0,
				"fontSize": fontSize,
				"color": "#68737D",
				"labelFunction": function(valueText: any, serialDataItem: any, categoryAxis: any)
				{
					return String(serialDataItem.category * 10)
				},
			}
		});

		function stopGradient()
		{
			clearInterval(gradient);
			zepi_drawn = true;
		}

		var gradient = setInterval(function()
		{
			try
			{
				var min: any = $($('#zepi_chart .amcharts-category-axis .amcharts-axis-label')[0]).offset();
				var max: any = $($('#zepi_chart .amcharts-category-axis .amcharts-axis-label')[10]).offset();
				var width = max.left - min.left - 7;
				var top = min.top - 17;
				var left = Math.abs((min.left + 13) - (window.innerWidth * 0.17));
				top += 40;
				$(".zepi_gradient").css("width", width + "px");
				// $(".zepi_gradient").css("top", top + "px");
				$(".zepi_gradient").css("left", left + "px");

				// $(".zepi_gradient_100").css("top", (top + 5 + 8) + "px");
				$(".zepi_gradient_100").css("left", left + "px");

				// $(".zepi_gradient_60").css("top", (top + 5 + 8) + "px");
				$(".zepi_gradient_60").css("left", (left + (width * 0.4)) + "px");

				// $(".zepi_gradient_50").css("top", (top + 5 + 8) + "px");
				$(".zepi_gradient_50").css("left", (left + (width * 0.5)) + "px");

				// $(".zepi_gradient_0").css("top", (top + 5 + 8) + "px");
				$(".zepi_gradient_0").css("left", (left + (width * 1)) + "px");
				stopGradient();
			}
			catch(e)
			{

			}
		}, 1);
	}

	drawChart(data: any, chart_id: string, color: string)
	{
		data.sort(function(a: any, b: any)
		{
			return a.reduction - b.reduction
		});

		var ballon = '<div class="ballon"><p class="heading">Project(s)</p><div class="values">[[projects]]</div></div>';
		var fontSize = 13;
		var chart = AmCharts.makeChart(chart_id,
		{
			"type": "serial",
			"theme": "light",
			"dataProvider": data,
			"valueAxes": [
			{
				"gridThickness": 1.5,
				"labelsEnabled": true,
				"integersOnly": true,
				"minimum": 0,
				"strictMinMax": true,
				"fontSize": fontSize,
				"color": "#68737D",
				"titleColor": "#68737D",
				"axisAlpha": 0,
				"gridAlpha": 0.5,
				"gridColor": "#DDDDDD",
				"axisColor": "#DDDDDD",
			}],
			"gridAboveGraphs": true,
			"startDuration": 1,
			"graphs": [
			{
				"id": "g1",
				"balloonText": ballon,
				"fillAlphas": 0.9,
				"lineAlpha": 0.2,
				"type": "column",
				"valueField": "projects",
				"lineColor": color,
				"fixedColumnWidth": 24,
				"balloonColor": "white",
				"balloon": {
					"borderAlpha": 0,
					"borderThickness": 0,
					"fillAlpha": 0
				},
				"labelText": "[[projects]]",
				"labelPosition": "top"
			}],
			"categoryField": "reduction",
			"categoryAxis":
			{
				"gridAlpha": 0,
				"titleBold": false,
				"axisThickness": 1.5,
				"axisColor": "lightgrey",
				"fontSize": fontSize,
				"color": "#68737D",
				"labelFunction": function(valueText: any, serialDataItem: any, categoryAxis: any)
				{
					return String(serialDataItem.category) + '%'
				},
			},
			"chartCursor":
			{
				"limitToGraph": "g1",
				"cursorColor": color
			},
		});
	}

	toggleMetrics(tab: string)
	{
		this.metric_tab = tab;
		if(tab == 'Metrics')
		{
			this.zEPIChart(this.insight_data.reduction.energy.list);
			if(!water_drawn)
			{
				this.drawChart(this.insight_data.reduction.water.list, 'water_reduction_chart', "#51C2F7");
				water_drawn = true;
			}
			if(!waste_drawn)
			{
				this.drawChart(this.insight_data.reduction.waste.list, 'waste_diversion_chart', "#84CCB0");
				waste_drawn = true;
			}
		}
	}

	paginateArray(list: any, page_size: any, page_number: any)
	{
		if(page_number < 1)
		{
			page_number = 1;
		}
		else if(page_number > this.pages)
		{
			page_number = this.pages;
		}
		this.page_number = page_number;
		this.page_size = page_size;
		this.pages = Math.ceil(list.length / this.page_size);
		this.project_list = list.slice((page_number - 1) * page_size , ((page_number - 1) * page_size ) + page_size);
	}

	showDropdown()
	{
		if(this.zipcode_list.length > 0)
		{
			$('.dropdown.zipcode .dropdown-menu').slideDown(200);
		}
	}
	
	hideDropdown()
	{
		$('.dropdown.zipcode .dropdown-menu').slideUp(200);
	}
	
	initPieChart()
	{
		if(this.loading_data)
		{
			return
		}
		var data = google.visualization.arrayToDataTable(this.project_certs);

		var options = {
			colors: ['#a5ba48', '#d5ae00', '#83bbc9', '#818183'],
			pieHole: 0.6,
			pieSliceText: 'none',
			legend: {
				position: 'none'
			}
		};
		
		try
		{
			var chart = new google.visualization.PieChart(document.getElementById('piechart'));
		}
		catch(e)
		{}
		try
		{
			chart.draw(data, options);
		}
		catch(e)
		{}
	}
}
